import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-solid-svg-icons';
import type { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FormattedMessage, defineMessages } from 'react-intl';
import Loader from '../Loader';
import React from 'react';

const messages = defineMessages({
  saved: {
    id: 'form.formHeader.savedIndicator.saved',
    defaultMessage: 'Saved',
  },
  saving: {
    id: 'form.formHeader.savedIndicator.saving',
    defaultMessage: 'Saving..',
  },
});

type SavedIndicatorProps = {
  isUpdateLoading: boolean;
};

const SavedIndicator = ({ isUpdateLoading }: SavedIndicatorProps) => (
  <div className={'mr-[0.81rem] px-[0.62rem] py-[0.75rem] w-[6.25rem]'}>
    {!isUpdateLoading ? (
      <div className="flex items-center justify-center font-medium  text-sm text-[#6B7280]">
        <FontAwesomeIcon icon={faCheck as IconProp} className="mr-[0.5rem]" />
        <FormattedMessage {...messages.saved} />
      </div>
    ) : (
      <div className="flex items-center justify-center justify-items-center">
        <Loader />
        <div className="text-sm text-[#6B7280] font-medium">
          <FormattedMessage {...messages.saving} />
        </div>
      </div>
    )}
  </div>
);
export default SavedIndicator;
